<template>
  <v-card color="d-flex" height="200" class="mb-3">
    <v-card-text style="position: relative;" class="align-self-stretch">
      <!--    -->
      <v-row v-if="loading" style="position: absolute; left: 12px; top:0px; width: 100%; height: 100%;" justify="center" align="center">
        <v-progress-circular indeterminate color="accent" size="64"/>
      </v-row>
      <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px" >
        <v-col :cols="12" class="d-flex flex-column justify-space-between">
          <h6 class="d-flex body-1 ml-1 mt-0">Meine Lebenssäulen diese Woche</h6>
          <v-row class="justify-space-between pt-5 mr-3 ml-3 flex-grow-0 flex-shrink-1">
            <v-col class="pa-0 flex-grow-0 flex-shrink-0" style="min-width: 45px;" v-for="(bereich,i) in bereiche" :key="bereich">
              <div class="display-1 text-center" :style="getTextStyle(bereich)">{{ calcWeekIndexForBereich(bereich)}}</div>
              <div class="caption text-center text-no-wrap">{{getBereichAbbr(i)}}</div>
            </v-col>
<!--            <div class="flex-grow-1"></div>-->
<!--            <div class="d-flex flex-column pa-0 flex-grow-0 flex-shrink-0">-->
<!--                <div class="text-center display-3">{{calcIndex(values[6])}}</div>-->
<!--                <div class="text-center caption">heute</div>-->
<!--            </div>-->


          </v-row>
        </v-col>
      </v-row>
      <bar-chart class="mt-5" ref="vuechart" :chartdata="chartData" :options="options" :height="80" />
    </v-card-text>
  </v-card>
</template>

<script>

import BarChart from "@/components/Charts/BarChart";
const {DateTime} = require("luxon");
import {round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";

export default {
  name: "BereichIndexWeek2",
  components: {BarChart},
  props: ['values', 'weights', 'loading', 'stacked'],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false,
            },
            stacked:true,
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false,
            },
            stacked:true,
          }]
        },
        layout: {
          padding: {
            left:-20,
            top: 5,
            right: -10,
          }
        },
        tooltips: {
          enabled: false
        }
      },
      chartData: {},
      canvas: undefined,
      chart: undefined,
    }
  },
  mounted() {
    console.log(this.$refs.vuechart)
    this.chart = this.$refs.vuechart._data._chart;
    this.canvas = this.chart.canvas;
    var self = this;
    this.$nextTick(() => self.updateChart());
  },
  methods: {
    getGradient() {
      if (!this.canvas)
        return "#ffdd00";
      // Create a linear gradient
      // The start gradient point is at x=20, y=0
      // The end gradient point is at x=220, y=0
      var ctx = this.canvas.getContext('2d');
      var gradient = ctx.createLinearGradient(0, 90, 0, -10);
      // Add three color stops
      gradient.addColorStop(0.2, '#ffca3700');
      //gradient.addColorStop(.5, 'cyan');
      gradient.addColorStop(1, '#ffca37f0');
      return gradient;
    },
    updateChart() {
      var datetime = DateTime.local().setLocale("de").plus({days: -6});
      var labels = [];
      for (var i = 0; i < this.bereiche.length; i++)
        labels.push(this.bereiche[i]);
      console.log({labels, values: this.values})
      this.chartData.labels = labels;
      this.chartData.datasets = this.getDatasets();
      if (this.chart)
        this.chart.update();
    },
    getDatasets() {
      var bereiche=Bereiche.NAMES;
      var colors = Bereiche.COLORS;
      var datasets=[];
      if (this.stacked) {
        var bereich_indices = [];
        for (var i = 0; i < bereiche.length; i++) {
          var bereich=bereiche[i];
          bereich_indices.push(this.calcWeekIndexForBereich(bereich));
        }
        var rest_indices = bereich_indices.map(x => x >= 100 ? 0 : 100 - x); // missed goals
        datasets.push({
          label: 'Bereichsindex',
          stack: "all",
          backgroundColor: colors,
          data: bereich_indices,
        })
        datasets.push({
          label: 'Verfehltes Bereichsziel',
          stack: "all",
          backgroundColor: '#ebebeb',
          data: rest_indices,
        })
        return datasets;
      }
      // bereiche nach einzelnen Tagen aufgesplittet
      for(var j=0; j<this.values.length; j++) {
        //var values=this.values.map(x=>(x[bereich]||0)*w); //
        var values=[];
        var rest_values = [];
        var value_colors=[];
        for(var i=0; i<bereiche.length; i++){
          var bereich=bereiche[i];
          var w= this.stacked ? (this.weights[bereich]||1.0) : 1.0;
          var x=(this.values[j]||{})[bereich]||0;
          values.push(x);
          rest_values.push((x >= 100*w ? 0 : 100*w-x));
          value_colors.push(colors[i]);
        }
        datasets.push({
          label: ''+j,
          stack: bereich+j,
          backgroundColor: value_colors,
          data: values,
        })
        datasets.push({
          label: ''+j,
          stack: bereich+j,
          backgroundColor: '#ebebeb',
          data: rest_values,
        })
      }
      return datasets;
    },
    calcIndices(values) {
      return values.map(x=>this.calcIndex(x));
    },
    calcIndex(value){
      if (!value)
        return 0;
      var index=0;
      Bereiche.NAMES.forEach(b=>{
        index+=(value[b]||0)*(this.weights[b]||1.0);
      });
      return round(index,2);
    },
    calcMeanIndex(values) {
      return Math.round(this.calcIndices(values).reduce((x,y)=>x+y, 0)/7.0);
    },
    calcWeekIndexForBereich(bereich) {
      var b_idx=0;
      this.values.forEach(x=>{
        b_idx+=((x||{})[bereich]||0); //*(this.weights[bereich]||1.0)
      });
      return Math.round(b_idx/7.0);
    },
    getTextStyle(bereich) {
      return { 'color':Bereiche.COLORS_BY_NAME[bereich]};
    },
    getBereichAbbr(i) {
      return Bereiche.ABBR[i];
    }
  },
  computed: {
    bereiche(){
      return Bereiche.NAMES;
    }
  },
  watch: {
    values: {
      //immediate:true,
      handler() {
        this.updateChart();
      }
    }
  }
}
</script>

<style scoped>

</style>